import { useRef, useState } from "react";
import { ProviderAppTile } from "./ProviderAppTile";
import { VERIFIED_INSURERS } from "../lib/verifiedInsurers";

// Iter-440 — Desktop hero insurer cluster (xl+). Brand recognition only: no
// links, no quote activity, no persistent selection. Anchored to the left
// hero column in em units of the 96px headline (wrapper is text-8xl, same as
// the h1 at xl), so it tracks "In 2 minutes." rather than the form edge.
// Click/tap = brief micro-feedback that returns to rest (~700ms).
const PICKS = ["geico", "liberty-mutual", "progressive", "travelers", "allstate"];
// Staggered 5-tile cluster: A B / C D / E — the fifth extends downward, not right.
const POS = [
  { x: 0, y: 12 },
  { x: 54, y: 0 },
  { x: 6, y: 60 },
  { x: 60, y: 48 },
  { x: 30, y: 98 },
];
const TILES = PICKS.map((slug) => VERIFIED_INSURERS.find((i) => i.slug === slug)).filter(Boolean);
const TAP_MS = 700;

export const HeroProviderCluster = () => {
  const [tapped, setTapped] = useState(null);
  const timer = useRef(null);
  const tap = (slug) => {
    clearTimeout(timer.current);
    setTapped(slug);
    timer.current = setTimeout(() => setTapped(null), TAP_MS);
  };
  return (
    <div
      role="img"
      aria-label={`Insurers in our comparison network include ${TILES.map((t) => t.name).join(", ")}`}
      data-testid="hero-provider-cluster"
      className="hidden xl:block absolute text-8xl left-[calc(5.7em+14px)] top-[calc(1.96em+2rem+10px)] w-[116px] h-[160px] z-20"
    >
      {TILES.map((ins, i) => (
        <span
          key={ins.slug}
          aria-hidden="true"
          data-testid={`hero-provider-${ins.slug}`}
          data-tapped={tapped === ins.slug ? "true" : undefined}
          onClick={() => tap(ins.slug)}
          className="hero-provider-chip absolute"
          style={{ left: POS[i].x, top: POS[i].y, zIndex: tapped === ins.slug ? 10 : i + 1, animationDelay: `${0.6 + i * 0.22}s` }}
        >
          <ProviderAppTile insurer={ins} state="color" size="sm" showLabel={false} decorative eager />
        </span>
      ))}
    </div>
  );
};

export default HeroProviderCluster;
